export * from './b64-to-canvas';
export * from './text-to-canvas';
export * from './turn-on-fullscreen';



// WEBPACK FOOTER //
// ./src/app/directives/index.ts